// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__0KgpJ","loadingWrapper":"Loading_loadingWrapper__9g6JR"};